'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemsList = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _reactIntl = require('react-intl');

var _reactDndJqueryBackend = require('@bibliocommons/react-dnd-jquery-backend');

var _reactDndJqueryBackend2 = _interopRequireDefault(_reactDndJqueryBackend);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseDragDrop = require('@bibliocommons/base-drag-drop');

var _baseAccessibilityManageFocus = require('@bibliocommons/base-accessibility-manage-focus');

var _baseAccessibilityManageFocus2 = _interopRequireDefault(_baseAccessibilityManageFocus);

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

var _utilsList = require('@bibliocommons/utils-list');

var _listItem = require('../../list-item');

var _listItem2 = _interopRequireDefault(_listItem);

require('../styles/ItemsList.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DragDropContextJQueryBackend = (0, _baseDragDrop.dragDropContext)((0, _reactDndJqueryBackend2.default)());

var findFirstDifferentItem = function findFirstDifferentItem(oldItems, newItems) {
  var i = void 0;
  var firstDifferentItem = null;

  for (i = 0; i < newItems.size; i += 1) {
    var currentItem = newItems.get(i);
    var oldItem = oldItems.get(i);
    firstDifferentItem = currentItem;
    if ((0, _utilsList.generateKeyForListItem)(currentItem) !== (0, _utilsList.generateKeyForListItem)(oldItem)) {
      break;
    }
  }

  return firstDifferentItem;
};

var ItemsList = exports.ItemsList = function (_BcReactComponent) {
  _inherits(ItemsList, _BcReactComponent);

  function ItemsList(props) {
    _classCallCheck(this, ItemsList);

    var _this = _possibleConstructorReturn(this, (ItemsList.__proto__ || Object.getPrototypeOf(ItemsList)).call(this, props));

    _this.bindAll('renderListCount');
    _this._listItems = {};
    _this.state = {
      showListOrderUpdatedMessage: false
    };
    return _this;
  }

  _createClass(ItemsList, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      this._listItems = {};
      if (this.props.items.size > nextProps.items.size) {
        this.props.restoreFocus();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.items.size > this.props.items.size) {
        // If an item was deleted, focus on the next item in the list
        var nextItem = findFirstDifferentItem(prevProps.items, this.props.items);
        if (nextItem) {
          var nextItemComponent = this._listItems[(0, _utilsList.generateKeyForListItem)(nextItem)];
          if (nextItemComponent) {
            this.props.captureFocus(nextItemComponent, false);
          }
        }
      }

      // Focus on newly added item if user can only add one item at a time
      if (!this.props.keepSearchResultsOpen && prevProps.items.size < this.props.items.size) {
        // focus on first or last
        var itemToFocusOn = this.props.addItemsToTop ? this.props.items.first() : this.props.items.last();
        var itemComponent = this._listItems[(0, _utilsList.generateKeyForListItem)(itemToFocusOn)];
        this.props.restoreFocus();
        this.props.captureFocus(itemComponent, false);
      }

      // Show message if list was re-ordered
      if ((0, _utilsList.listOrderHasChanged)(prevProps.items, this.props.items)) {
        this.showListOrderUpdatedMessage();
      }
    }
  }, {
    key: 'showListOrderUpdatedMessage',
    value: function showListOrderUpdatedMessage() {
      var _this2 = this;

      this.setState({ showListOrderUpdatedMessage: true });
      setTimeout(function () {
        _this2.setState({ showListOrderUpdatedMessage: false });
      }, 10000);
    }
  }, {
    key: 'renderListCount',
    value: function renderListCount() {
      if (!this.props.items || this.props.items.size === 0) {
        return false;
      }

      return _react2.default.createElement(
        'div',
        { className: 'item-count', 'data-test-id': 'item-count', role: 'status', 'aria-live': 'polite', 'aria-atomic': 'true' },
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'label_number_of_items', values: { count: this.props.items.size } })
      );
    }
  }, {
    key: 'renderListOrderUpdatedMessage',
    value: function renderListOrderUpdatedMessage() {
      if (this.state.showListOrderUpdatedMessage) {
        return _react2.default.createElement(
          _baseScreenReaderMessage2.default,
          null,
          _react2.default.createElement(
            _reactIntl.FormattedMessage,
            { id: 'user_list_order_updated' },
            function (message) {
              return _react2.default.createElement(
                'div',
                { role: 'status', 'aria-live': 'polite', 'aria-atomic': 'true' },
                message
              );
            }
          )
        );
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          items = _props.items,
          allowFreeText = _props.allowFreeText,
          handleRemoveItem = _props.handleRemoveItem,
          handleItemDragged = _props.handleItemDragged,
          handleItemPropertyChange = _props.handleItemPropertyChange,
          showItemIndexes = _props.showItemIndexes,
          handleItemMovedUp = _props.handleItemMovedUp,
          handleItemMovedDown = _props.handleItemMovedDown;


      return _react2.default.createElement(
        'div',
        { className: 'cp-user-list-items-list' },
        _react2.default.createElement(
          DragDropContextJQueryBackend,
          null,
          this.renderListCount(),
          this.renderListOrderUpdatedMessage(),
          _react2.default.createElement(
            _reactAddonsCssTransitionGroup2.default,
            { transitionName: 'fade', transitionEnterTimeout: 250, transitionLeaveTimeout: 250, component: 'ul' },
            items.map(function (item) {
              return _react2.default.createElement(
                'li',
                { className: 'list-item-wrapper', key: (0, _utilsList.generateKeyForListItem)(item) },
                _react2.default.createElement(_listItem2.default, {
                  ref: function ref(el) {
                    return _this3._listItems[(0, _utilsList.generateKeyForListItem)(item)] = el;
                  },
                  item: item,
                  itemIndex: items.indexOf(item),
                  isFirstItem: items.indexOf(item) === 0,
                  isLastItem: items.indexOf(item) === items.size - 1,
                  allowFreeText: allowFreeText,
                  showIndex: showItemIndexes,
                  handleRemoveItem: handleRemoveItem,
                  handleItemDragged: handleItemDragged,
                  handleItemMovedUp: handleItemMovedUp,
                  handleItemMovedDown: handleItemMovedDown,
                  handleItemPropertyChange: handleItemPropertyChange })
              );
            })
          )
        )
      );
    }
  }]);

  return ItemsList;
}(_baseBcReactComponent2.default);

ItemsList.propTypes = {
  items: _reactImmutableProptypes2.default.listOf(_bcPropTypes.listItemShape),
  allowFreeText: _react.PropTypes.bool.isRequired,
  handleItemPropertyChange: _react.PropTypes.func.isRequired,
  handleRemoveItem: _react.PropTypes.func.isRequired,
  handleItemDragged: _react.PropTypes.func.isRequired,
  showItemIndexes: _react.PropTypes.bool.isRequired,
  keepSearchResultsOpen: _react.PropTypes.bool,

  handleItemMovedUp: _react.PropTypes.func.isRequired,
  handleItemMovedDown: _react.PropTypes.func.isRequired,

  // Injected by manageFocus
  captureFocus: _react.PropTypes.func.isRequired,
  restoreFocus: _react.PropTypes.func.isRequired
};

exports.default = (0, _baseAccessibilityManageFocus2.default)(ItemsList);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/items-list/components/ItemsList.component.js
// module id = 1305
// module chunks = 0